var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_heador ",class:{
    heador_fixed: _vm.fixed,
    common_heador_KNOWLEDGE: _vm.isILocalizeFn(),
  }},[_c('div',{staticClass:"title"},[_vm._t("title-left"),_vm._v(" "+_vm._s(_vm.isILocalizeFn() ? "iLocalize Support" : _vm.title)+" "),_vm._t("title-right")],2),_c('div',{staticClass:"btn-wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }